import type { GetActivityListServiceConfig, GetRunningResourceActivitiesServiceConfig } from '@/services/httpServices/ActivityServices/types';

import { createQueryKey } from './queryKeyUtils';

export function activityListQueryKey(config?: GetActivityListServiceConfig) {
  return createQueryKey(['activities', 'list'], config);
}

/**
 * Creates a unique query key for infinite activity list queries
 * Includes 'infinite' prefix to differentiate from regular list queries
 */
export function infiniteActivityListKeys(config?: GetActivityListServiceConfig) {
  return ['infinite', ...activityListQueryKey(config)];
}

export function runningResourceActivitiesQueryKey(config?: GetRunningResourceActivitiesServiceConfig) {
  return createQueryKey(['activities', 'running'], config);
}
